var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FilterLiteral_1;
/* eslint-disable import/no-duplicates */
import '@symon-ai/wisepipe-base-pipe'; // force import for JsonSchema
import { StringToolVariable } from '@symon-ai/wisepipe-base-pipe';
import { DateConverter, JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { FilterOperand, FilterOperandType } from './filterOperand';
export var FilterLiteralType;
(function (FilterLiteralType) {
    FilterLiteralType["STRING"] = "string";
    FilterLiteralType["NUMBER"] = "number";
    FilterLiteralType["DATE"] = "date";
    FilterLiteralType["BOOLEAN"] = "boolean";
})(FilterLiteralType || (FilterLiteralType = {}));
const schema = {
    $id: 'urn:wisepipe-common-pipe:FilterLiteral',
    type: 'object',
    properties: {
        litType: { type: 'string', enum: Object.values(FilterLiteralType) },
        value: {
            oneOf: [
                {
                    $ref: 'urn:wisepipe-base-pipe:StringToolVariable'
                },
                { type: 'string' }
            ]
        }
    },
    required: ['litType', 'value']
};
let FilterLiteral = FilterLiteral_1 = class FilterLiteral extends FilterOperand {
    constructor(litType, value) {
        super(FilterOperandType.LITERAL);
        this.litType = litType;
        this.value = value;
        JSON.validate(this, FilterLiteral_1);
    }
    // used for filter tool inside Case tool
    get formulaString() {
        switch (this.litType) {
            case FilterLiteralType.STRING: {
                if (this.value instanceof StringToolVariable)
                    throw new Error('Apply parameters before using');
                // escape double quotes from user input to prevent injection
                const escapedValue = this.value.replace(/"/g, '\\"');
                return `"${escapedValue}"`;
            }
            case FilterLiteralType.DATE: {
                const converter = new DateConverter('date-time');
                if (this.value instanceof StringToolVariable)
                    throw new Error('Apply parameters before using');
                const date = converter.deserialize(this.value);
                // need Date in the form 'Date(yyyy,mm,dd)'
                // TODO: TBD Potential bug here: instead of treating the date as UTC, we are treating it as local time
                // The right way (not tested though) is to uncomment this line:
                // return `Date(${date!.getUTCFullYear()},${date!.getUTCMonth() + 1},${date!.getUTCDate()})`;
                return `Date(${date.getFullYear()},${date.getMonth() + 1},${date.getDate()})`;
            }
            default:
                return `${this.value}`;
        }
    }
    static toFilterLiteralType(column) {
        switch (column) {
            case 'string':
            case 'period':
                return FilterLiteralType.STRING;
            case 'date':
                return FilterLiteralType.DATE;
            case 'decimal':
            case 'number':
                return FilterLiteralType.NUMBER;
            case 'boolean':
                return FilterLiteralType.BOOLEAN;
            default:
                throw new Error(`Unknown column type: ${column}`);
        }
    }
    applyParameters(parameters) {
        const baseVals = this.getBaseValues(parameters);
        return new FilterLiteral_1(baseVals.litType, baseVals.value);
    }
    getBaseValues(parameters) {
        return {
            // If num or any variable type other than string is passed into the filter, it needs to be converted to string
            value: `${parameters.getStrVal(this.value)}`,
            litType: this.litType
        };
    }
};
FilterLiteral = FilterLiteral_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(FilterOperandType.LITERAL)
], FilterLiteral);
export { FilterLiteral };
//# sourceMappingURL=filterLiteral.js.map